import { render, staticRenderFns } from "./InviteUsersModal.vue?vue&type=template&id=4d45c65c&"
import script from "./InviteUsersModal.vue?vue&type=script&lang=ts&"
export * from "./InviteUsersModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports